export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + "...";
}

export const allowOnlyNumbers = (event: any) => {
  // Allow numbers (0-9), backspace, delete, tab, escape, enter, and period (for decimals)
  if (
    ![
      '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
      'Backspace', 'Delete', 'Tab', 'Escape', 'Enter', '.',
    ].includes(event.key) &&
    event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' // Allow arrow keys for navigation
  ) {
    event.preventDefault(); // Prevent the default action (typing the character)
  }

  // Optional: Prevent multiple decimal points
  if (event.key === '.' && event.target.value.includes('.')) {
    event.preventDefault();
  }
};

export const companyNameFilter = (searchQuery: string) => (fleetOwner: { companyName: string; }) => fleetOwner.companyName?.toLowerCase().includes(searchQuery.toLowerCase());
